export default __webpack_public_path__ + "static/media/about-hero.28b0e05d.png";